import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (
  theme,
  mainColor,
  secondaryColor,
  iconColor,
  width,
  height
) => ({
  icon: {
    p: "5px",
    height: {
      xs: "13px",
      sm: "11.25px",
      md: "12.5px",
      lg: "13.75",
      xl: "15px",
    },
    width: { xs: "13px", sm: "11.25px", md: "12.5px", lg: "13.75", xl: "15px" },
    borderRadius: "58px",
    bgcolor: theme.palette.white.secondary,
    color: iconColor,
    ml: { xs: "3px", sm: "6px", md: "9px", lg: "12px", xl: "15px" },
  },
  button: {
    borderRadius: "100px",
    color: theme.palette.white.secondary,
    background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    fontSize: {
      xs: "14px",
      sm: "14.5px",
      md: "15px",
      lg: "15.5px",
      xl: "16px",
    },
    lineHeight: {
      xs: "25.2px",
      sm: "27",
      md: "28.8",
      lg: "30.6",
      xl: "32.4px",
    },
    height,
    width: {
      xs: "165px",
      sm: "179.5px",
      md: width ? width : "203px",
      lg: width ? width : "226.5",
      xl: width ? width : "245px",
    },
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.secondary,
      background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    },
    letterSpacing: { xs: "0.32px", md: "0.36px" },
  },
});

const IntroButton = ({
  mb,
  mt,
  mainColor,
  secondaryColor,
  iconColor,
  width,
  height,
}) => {
  const theme = useTheme();
  const classes = useStyles(
    theme,
    mainColor,
    secondaryColor,
    iconColor,
    width,
    height
  );

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "IntroButton");

  const handleRedirect = () => {
    navigate("/intro");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Button
      endIcon={<ArrowForwardIosIcon sx={classes.icon} />}
      variant="contained"
      sx={{ ...classes.button, mb, mt }}
      onClick={handleRedirect}
    >
      {title}
    </Button>
  );
};

export default IntroButton;
